import { QueryClient, QueryCache, MutationCache } from "@tanstack/react-query"
import { expireSession, isAuthError } from "@/lib/auth/session"

const onError = (error: unknown) => {
  if (isAuthError(error)) expireSession()
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError }),
  mutationCache: new MutationCache({ onError }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
})
